/**
 * Shared visual language for the PRC-001 Pricing Tiers admin surface.
 * Updated to SUT brand palette (teal #007C84) while keeping per-metric
 * accent gradients for data visualisation chips.
 */

export const PRC_GRADIENTS = {
  emerald:  ["#34D399", "#059669"],
  cyan:     ["#22D3EE", "#0891B2"],
  indigo:   ["#6366F1", "#4F46E5"],
  amber:    ["#FBBF24", "#EA580C"],
  rose:     ["#FB7185", "#E11D48"],
  slate:    ["#CBD5E1", "#94A3B8"],
  // SUT teal — used for the primary action gradient
  teal:     ["#34D3CC", "#007C84"],
};

export const PRC_BG = {
  page:             "#F7FAFC",
  cardBorder:       "#E2E8F0",
  cardBorderActive: "#80CCCC",
  rowHover:         "#F0FAFA",
  zebra:            "#F8FAFC",
  fullTruck:        "#FEF3C7",
  fullTruckBorder:  "#FCD34D",
};

// ── SUT teal header — replaces the old emerald→cyan→indigo gradient ──────
export const PRC_HEADER_GRADIENT =
  "linear-gradient(135deg, #007C84 0%, #016268 55%, #005559 100%)";

// ── Primary action gradient — Edit buttons, dialog Save buttons ──────────
export const PRC_PRIMARY_GRADIENT =
  "linear-gradient(135deg, #007C84, #016268)";

export const PRC_PRIMARY_GRADIENT_HOVER =
  "linear-gradient(135deg, #016268, #014f54)";

export const PRC_PRIMARY_SHADOW = "0 4px 12px rgba(0,124,132,0.30)";
